import { render, staticRenderFns } from "./AirportSelectComponent.vue?vue&type=template&id=506f277a"
import script from "./AirportSelectComponent.vue?vue&type=script&lang=js"
export * from "./AirportSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports